import { HiOutlineUserCircle } from 'react-icons/hi';
import { AiOutlineMan, AiOutlineWoman } from 'react-icons/ai';
import { MdOutlineSupervisedUserCircle } from 'react-icons/md';

export const options = {
  flex: 1,
  sortable: false,
  disableColumnMenu: true,
};

export const optionsEnd = {
  headerName: '',
  width: 130,
  field: 'system',
  end: true,
};

export const buttonGroup = [
  { title: 'Действующий', value: 'active' },
  { title: 'Не действующий', value: 'in_active' },
];

export const buttonProgramm = [
  { title: 'Семейная', value: 'family' },
  { title: 'Индивидуальная', value: 'individual' },
];

export const buttonTerm = [
  { title: 'На семью', value: 'overall' },
  // { title: 'На одного человека', value: 'individual' },
];

export const buttonTerm2 = [
  { title: 'На одного человека', value: 'individual' },
  // { title: 'На семью', value: 'overall' },
];

export const buttonGroup3 = [
  { title: 'Срочный', value: 'true' },
  { title: 'Бессрочный', value: 'false' },
];

export const buttonGroup4 = [
  { title: 'Активен', value: 'active' },
  { title: 'Не активен', value: 'in_active' },
];

export const buttonGroup5 = [
  {
    value: 'male',
    title: 'Мужской',
    icon: <AiOutlineMan size={20} />,
  },
  {
    value: 'female',
    title: 'Женский',
    icon: <AiOutlineWoman size={20} />,
  },
];

export const buttonGroup6 = [
  {
    value: 'individual',
    title: 'Индивидуальный',
    icon: <HiOutlineUserCircle size={20} />,
  },
  {
    value: 'family',
    title: 'Семейный',
    icon: <MdOutlineSupervisedUserCircle size={20} />,
  },
];

export const buttonGroup7 = [
  { title: 'Семейный с индивидуальными лимитами', value: 'complex_individual' },
  { title: 'Семейный базовый полис', value: 'basic' },
  { title: 'Семейный сложный', value: 'complex_general' },
];

export const buttonGroup8 = [
  {
    value: 'family',
    title: 'Семейный',
    icon: <MdOutlineSupervisedUserCircle size={20} />,
  },
];

export const buttonGroup9 = [
  {
    value: '1',
    title: 'Юридическое',
  },
  {
    value: '2',
    title: 'Физическое',
  },
];

export const buttonGroup10 = [
  {
    title: 'Да',
    value: 'true',
  },
  {
    title: 'Нет',
    value: 'false',
  },
];

export const roleList = {
  results: [
    {
      id: 'super_admin',
      label: 'Супер админ',
    },
    {
      id: 'administrator',
      label: 'Администратор',
    },
    {
      id: 'operator',
      label: 'Оператор',
    },
  ],
};

export const countItems: any = [
  {
    label: '10',
    value: 10,
  },
  {
    label: '20',
    value: 20,
  },
  {
    label: '50',
    value: 50,
  },
  {
    label: '100',
    value: 100,
  },
];
